/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Generated bundle index. Do not edit.
 */
export { ThemeModule } from './theme.module';
export { ThemeComponent as ɵa } from './theme.component';
//# sourceMappingURL=index.js.map